module.exports = "<div fxLayout='row' *ngIf='show == true'>\n  <div fxFlex='100'>\n    <md-progress-spinner class='progress-circle' style=\"width: 50%; margin: 0 auto; padding-top: 10px;\" mode=\"indeterminate\"></md-progress-spinner>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader/loader.component.html
// module id = ./src/app/shared/loader/loader.component.html
// module chunks = main